export default {
    appName: 'MOEX Digital platform',
    serviceNotAvailable: 'The service is temporarily unavailable',
    tryAgainLater: 'Please try again in 5 minutes or later',
    goBackHome: 'Return to homepage',
    pageNotExist: 'This page no longer exists or never existed',
};
